import * as React from 'react'

import { Box, SearchField } from '@factorialco/deprecated-design-system'
import isEmpty from 'lodash/isEmpty'

import { observer } from 'mobx-react'

import createComputed from 'modules/core/hooks/createComputed'
import { useDebouncedSearch } from 'modules/core/hooks/useSearch'
import i18n from 'modules/core/lib/i18n'
import { matchText } from 'modules/core/lib/stringUtils'

import type TimeoffPolicy from 'modules/timeoff/store/models/TimeoffPolicy/Policy'

import Controls from './_Controls'
import List from './_List'

interface Props {
  timeoffPolicies: TimeoffPolicy[]
  onSelectMultiple: (selectedIds: string[]) => void
  onSelect: (id: string | null | undefined) => void
  selectedIds: string[]
}

const useSearchFilter = createComputed((collection: TimeoffPolicy[], search: string) =>
  collection.filter((model) => matchText(search, model.attributes.name))
)

const TimeoffPoliciesSelector = ({
  timeoffPolicies,
  onSelectMultiple,
  onSelect,
  selectedIds,
}: Props) => {
  const onSelectTimeoffPolicy = (policy: TimeoffPolicy) => () => {
    const hasOvertimeAllowance = !isEmpty(policy.overtimeAllowances)
    if (hasOvertimeAllowance) {
      return onSelect(null)
    }
    onSelect(policy.attributes.id)
  }
  const { search, debouncedSearch, onSearch } = useDebouncedSearch()
  const filteredTimeoffPolicies = useSearchFilter(timeoffPolicies, debouncedSearch).get()

  return (
    <Box
      borderRadius={{ all: 'abs006' }}
      border={{ all: { width: 's2', color: 'grey400', style: 'solid' } }}
    >
      <Box
        width="full"
        padding="s8"
        background="grey200"
        borderRadius={{ topLeft: 'abs004', topRight: 'abs004' }}
      >
        <SearchField
          variant="big"
          search={search}
          onSearch={onSearch}
          placeholder={i18n.t('common.search')}
        />
      </Box>
      <Controls
        timeoffPolicies={filteredTimeoffPolicies}
        disabled={false}
        selectedIds={selectedIds}
        onSelectMultiple={onSelectMultiple}
      />
      <List
        onSelectMultiple={(selectedIds) => onSelectMultiple(selectedIds)}
        onSelectTimeoffPolicy={onSelectTimeoffPolicy}
        selectedIds={selectedIds}
        timeoffPolicies={filteredTimeoffPolicies}
      />
    </Box>
  )
}

export default observer(TimeoffPoliciesSelector)
